var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "指定发货仓",
            visible: _vm.dialogVisible,
            width: "950px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("RightDeliveryWarehouse", {
            ref: "RightDeliveryWarehouse",
            attrs: { disabled: _vm.disabled, "show-reset-btn": "" },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v("下一步")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("AppointLogistics", {
        ref: "AppointLogistics",
        attrs: { "show-last-btn": "" },
        on: { confirm: _vm.getLogisticsData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }